import { isNonEmpty } from '@sgme/fp';
import { WithCopy } from 'components/shared/WithCopy/WithCopy';
import type { IntlKey } from 'locales';
import { FC, useMemo } from 'react';
import { useIntl } from 'react-intl';

interface ErrorTooltipHeaderProps {
  title: IntlKey;
  messages?: string[];
  canCopy?: boolean;
  content?: string;
}

export const ErrorTooltipHeader: FC<ErrorTooltipHeaderProps> = ({
  canCopy = false,
  messages,
  content,
  title: titleIntlKey,
}) => {
  const intl = useIntl();

  const title = intl.formatMessage({ id: titleIntlKey });
  const contentToCopy = useMemo(() => {
    if (isNonEmpty(content)) {
      return content;
    }
    return isNonEmpty(messages) ? JSON.stringify(messages, undefined, 2) : title;
  }, [content, messages, title]);

  return (
    <div data-e2e="tooltip-header" className="d-flex justify-content-between align-items-center">
      <div className="fw-bold text-start ps-1" data-e2e="tooltip-title">
        {title}
      </div>
      {canCopy && (
        <WithCopy content={contentToCopy}>
          <button className="btn btn-sm btn-flat-primary-alt" data-e2e="tooltip-copy-button" type="button">
            <em className="icon icon-sm">content_copy</em>
          </button>
        </WithCopy>
      )}
    </div>
  );
};
